import { ComplexTable } from 'aa_common/front-end/antd'

import { getColumns } from '../../helpers/accelerated-depr-history'
import { usePrepareAdjustDepreciation } from '../../hooks/use-prepare-adjust-depreciation'
import { acceleratedEventLogStore } from '../../store/accelerated-log'
import { AcceleratedTable } from './styles'

export const AcceleratedDepreciationTable = ({ isRegisterEvent }: { isRegisterEvent: boolean }) => {
  const adjustHistory = acceleratedEventLogStore.useSlice(state => state.data)
  const dataSource = usePrepareAdjustDepreciation(adjustHistory, isRegisterEvent)

  return (
    <AcceleratedTable>
      <ComplexTable actions={false} enableSelectRows={false} columns={getColumns()} data={dataSource} />
    </AcceleratedTable>
  )
}
